import React, { Component } from "react";
import {
  Button,
  Icon,
  Tooltip,
  Typography,
  Badge,
  Modal,
  Row,
  Col,
  Collapse,
} from "antd";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import NumberFormat from "./NumberFormat";
import ScreenContainer from "../newSrc/shared/containers/ScreenContainer";
import { Provider } from "react-redux";
import { store } from "../redux";
import placeholder from "../images/bg.jpg";
import { withTranslation } from 'react-i18next';
import { BundleSvg } from "../images/customIcons/BundleSvg";
import { checkIfBundle, circuitHasMultipleFaces, displayIsCircuit, displayIsMultipleFaces, getLocationType, getMultipleFacesCountInCircuit, getTotalMultipleFacesInCircuit } from "../services/display";
import { isRemoveDisabledInApproved } from "../services/campaignManager";
import Colors from "../themes/Colors";
import CircuitButton from "./customComponents/CircuitButton/CircuitButton";
import MultipleFacesButton from "./customComponents/MultipleFacesButton/MultipleFacesButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";

const Panel = Collapse.Panel;

const { Paragraph } = Typography;

class MapScreenInfoBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showScreenDetail: false,
      defaultTabScreenDetail: null,
      displaysAudience: [],
    };
  }

  getSizeType(type) {
    const { t } = this.props;

    if (type === "small") {
      return t("Small");
    }
    if (type === "medium") {
      return t("Medium");
    }
    if (type === "big") {
      return t("Big");
    }
    if (type === "giant") {
      return t("Giant");
    }
  }

  countDisplays(display) {
    let count = 0;
    display.forEach((display) => {
      count += display.mirror_screens_count;
    });
    return count;
  }

  handleShowScreenDetail = (defaultTabScreenDetail) => {
    this.setState((prevState) => ({
      showScreenDetail: !prevState.showScreenDetail,
    }))
    if (defaultTabScreenDetail != "close"){
      this.setState(() => ({
        defaultTabScreenDetail: defaultTabScreenDetail,
      }));
    }
  };

  render() {
    const {
      t,
      display,
      onCart,
      handleClose,
      paymentStatus,
      addDisplayToCart,
      removeDisplayFromCart,
      listBundle,
    } = this.props;

    const { showScreenDetail , defaultTabScreenDetail} = this.state;
    const customPanelStyle = {
      background: "transparent",
      border: 0,
      width: "100%",
      justifyContent: "center",
    };
  
    let countBundlesAdded = checkIfBundle (display.bundles, listBundle)
    let infoCircuit = display.name_secondary_display ? display.name : null
    let countSecondaryDisplays = this.countDisplays(display.secondary_displays);
    const disableRemove = isRemoveDisabledInApproved({
      paymentStatus,
      editCampaignActive: this.props.editCampaignActive,
      onCart,
      displayId: display.id,
      initialBackup: this.props.initialBackup,
      hasInitialBackup: this.props.hasInitialBackup,
    });
    let capFirstLetter = (display.name_secondary_display ? display.name_secondary_display : display.name)[0].toUpperCase();
    let restOfName = (display.name_secondary_display ? display.name_secondary_display : display.name).slice(1);
    const modalWidth = window.innerWidth > 1200 ? 1200 : window.innerWidth > 992 ? 900 : window.innerWidth;

    return (
      <InfoBox
        onCloseClick={() => handleClose()}
        options={{
          closeBoxURL: ``,
          enableEventPropagation: true,
          disableAutoPan: true,
          boxStyle: {},
        }}
      >
        <>
          <Button
            className="screenCardMapCloseButton"
            onClick={() => handleClose()}
            shape="circle"
            icon="close"
          />
          <div className="screenCardMap">
            <div className="screenCardMapContent">
              <Row type={"flex"} style={{ width: "100%" }}>
                <Col 
                  className="screenCardMapPrice"
                  style={this.props.programmatic === "programmatic" ? { alignItems: "center", flexDirection: "column" } : {}}
                >
                  <NumberFormat
                    value={
                      this.props.programmatic === "programmatic"
                        ? display.cpmi
                        : display.price_per_day
                    }
                    currency={display.price_currency}
                    include_currency={true}
                  />
                  {this.props.programmatic === "programmatic"
                    ? t("CPM")
                    : " / " + t("Day")}
                </Col>
              </Row>
              <Row
                type={"flex"}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <Collapse
                  bordered={false}
                  defaultActiveKey={["1"]}
                  style={{
                    backgroundColor: "transparent",
                    width: "100%",
                    justifyContent: "center",
                  }}
                  className="customContent"
                >
                  <Panel
                    header={capFirstLetter + restOfName.toLowerCase()}
                    key="1"
                    showArrow={false}
                    style={customPanelStyle}
                    className="customHeader"
                  >
                    <img
                      src={
                        display.pictures.length > 0
                          ? display.pictures[0].url
                              .split(".")
                              .slice(0, -1)
                              .join(".") + "-thumb.jpg"
                          : placeholder
                      }
                      className="screenCardMapImage"
                      alt=""
                    />
                    <div
                      style={{ fontSize: "12px", color: Colors.primaryAccent, marginTop: "5px" }}
                    >{display.resolution_width} x {display.resolution_height}</div>
                  </Panel>
                  { infoCircuit ? (
                      <>
                        <p style={{textAlign: "center", paddingRight: "15px", paddingLeft: "15px"}}>
                          {t("Screen belonging to the circuit")} <strong> {infoCircuit} </strong>
                        </p>
                        <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginBottom: "10px"}}>
                          <CircuitButton secondaryDisplays={display.secondary_displays} />
                        </div>
                        <p style={{textAlign: "center", fontSize: "10px", color: `${Colors.red}a6`, marginBottom: "10px"}}>
                          {t("It is not possible to purchase these screens individually.")}
                        </p>
                      </>
                    ) : null
                  }
                  {displayIsMultipleFaces(display) &&
                    <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginBottom: "15px"}}>
                      <MultipleFacesButton mirror_screens_count={display.mirror_screens_count} />
                    </div>
                  }
                </Collapse>
              </Row>
              <div className="screenCardButtonsContainer" align="center">
                {
                  displayIsCircuit(display) && circuitHasMultipleFaces(display.secondary_displays) ? (
                    <Tooltip
                      placement="bottomLeft"
                      title={
                        <>
                          {t("Multiple faces screen")}:
                          <br />
                          {getMultipleFacesCountInCircuit(this.props.display.secondary_displays)} {t("screens_abbreviated")} / {getTotalMultipleFacesInCircuit(this.props.display.secondary_displays)} {t("faces")}
                        </>
                      }
                    >
                      <Button
                        shape="circle" className="screenCardMapButton"
                      >
                        <FontAwesomeIcon
                          icon={faClone}
                          size="20x"
                          className="iconTranslate"
                        />
                      </Button>
                    </Tooltip>
                  ) : null
                }
                {display.display_type === "main" ? (
                  <Tooltip
                    placement="top"
                    title={`${t("Circuit")} ${getLocationType(display.location_type, t) || ""} ${display.sync_circuit ? t("sync") : ""}`}
                  >
                    <Button shape="circle" className="screenCardMapButton">
                      <Icon
                        style={{
                          fontSize: "20px",
                          paddingTop: "3px",
                        }}
                        type="deployment-unit"
                        theme="outlined"
                      />
                    </Button>
                  </Tooltip>
                ) : null}
                <span style={{ marginRight: "5px" }}>
                  <Tooltip placement="top" title={t("Screen detail")}>
                    <Button
                      shape="circle"
                      onClick={() => this.handleShowScreenDetail(("info"))}
                    >
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: "20px",
                          paddingTop: "3px",
                          color: Colors.primaryAccent,
                        }}
                      />
                    </Button>
                  </Tooltip>
                </span>
                <Modal
                  title={t("Screen detail")}
                  visible={showScreenDetail}
                  onCancel={() =>this.handleShowScreenDetail("close")}
                  footer={[
                    <Button key="back" onClick={() =>this.handleShowScreenDetail("close")}>
                      OK
                    </Button>,
                  ]}
                  width={modalWidth}
                  style={{ top: "10px" }}
                >
                  <Provider store={store}>
                    <ScreenContainer
                      display={display}
                      screenDetail={showScreenDetail}
                      popup={true}
                      // Tab for bundles
                      defaultTab={defaultTabScreenDetail}
                      editCart={true}
                      closeModal={() => this.handleShowScreenDetail("close")}
                    />
                  </Provider>
                </Modal>
                { display.bundles && display.bundles.length > 0 ?
                    <Tooltip placement="top" title={t("Sales bundle details")}>
                      <Button
                        style={{marginLeft: "1px", marginRight: "3px"}}
                        shape="circle"
                        onClick={() => this.handleShowScreenDetail("bundles")}
                      >
                       <Badge
                          count={
                            <>
                              {display.bundles.length > 0 && (
                                countBundlesAdded !== 0 && countBundlesAdded < display.bundles.length ? (
                                  <>
                                    <Icon type="plus-circle" className="addIconBundle" theme="filled"/>
                                    <Icon type="minus-circle" className="minusIconBundle" theme="filled"/>
                                  </>
                                ) : (
                                  countBundlesAdded === display.bundles.length ?
                                    <Icon type="minus-circle" className="minusIconBundle" theme="filled"/>:
                                    <Icon type="plus-circle" className="addIconBundle" theme="filled"/>
                                )
                              )}
                            </>
                          }
                      >
                      <Icon component={BundleSvg} style={{ width: '30px'}}/>
                      </Badge>
                      </Button>
                    </Tooltip>
                  :null}
                {!display.bundle_only ? (
                  <Tooltip
                    placement="top"
                    title={disableRemove ? t("To remove this screen, advance to the next step and transfer its outputs to another screen.") : null}
                  >
                  <Button
                    shape="circle"
                    className={
                      onCart
                        ? "screenCardMapButtonErase"
                        : "screenCardMapButton"
                    }
                    disabled={disableRemove}
                    onClick={() => {
                      if (onCart) {
                        removeDisplayFromCart(display.id);
                      } else {
                        addDisplayToCart(display);
                      }
                      // onCart = !onCart;
                    }}
                  >
                    {onCart ? (
                      <Badge
                        count={
                          <Icon
                            type="minus-circle"
                            theme="twoTone"
                            style={{
                              color: Colors.red,
                              fontSize: "14px",
                              paddingTop: "2px",
                              paddingRight: "2px",
                              bottom: "-3px",
                              left: "15px",
                            }}
                          />
                        }
                      >
                        <Icon
                          style={{ fontSize: "15px" }}
                          type="plus"
                          theme="outlined"
                        />
                      </Badge>
                    ) : (
                      <Icon
                        style={{
                          fontSize: "16px",
                          paddingTop: "3px",
                        }}
                        type="plus"
                        theme="outlined"
                      />
                    )}
                  </Button>
                  </Tooltip>
                ) : null}
              </div>
            </div>
          </div>
        </>
      </InfoBox>
    );
  }
}

export default withTranslation()(MapScreenInfoBox);
